<template>
  <div class="container-xxl vh-100">
    <div class="row pt-5">
      <div class="col-12">
        <h1>Page not found!</h1>
        <p>Whoops! Looks like you got on the wrong ride, please click below to go back to the homepage</p>
        <router-link to="/">
          <button class="btn btn-primary py-3 px-3">Back to Homepage</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import NavBar from "@/components/NavBar.vue";

export default {
  name: 'PageNotFound',
  components: {NavBar, Footer}
};
</script>
